<template>
  <div>
    <div class="parent" :style="style">
      <v-card @click="showSchoolDetail">
        <div class="parent-side">
          <v-card-title class="info-title">
            <div class="text-center">
              {{ school.schoolName }}
            </div>
          </v-card-title>
          <div>
            <app-row title="مجوزتدریس:" :value="school.sath" />
            <app-row title="جنسیت:" :value="school.jensiatString" />
            <app-row title="تعدادطلاب:" :value="school.studentCount" />
            <div
              style="padding: 0px 15px;
  margin: 0 !important;"
            >
              <span class="introductionTitle"> معرفی: </span>
              <div class="croppedText">
                {{ school.introduction }}
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["school"],
  components: {
    appRow: DetailRow,
  },
  created() {
    this.school.jensiatString =
      this.school.jensiatSerial === "1" ? "برادران" : "خواهران";
    this.school.sath =
      `سطوح  ${this.school.isSath1 === "True" ? " 1" : ""}` +
      `${this.school.isSath2 === "True" ? " 2" : ""}` +
      `${this.school.isSath3 === "True" ? " 3" : ""}`;
  },
  data: () => ({
    show: false,
  }),
  methods: {
    showSchoolDetail() {
      this.$emit("clicked", this.schoolSerial);
    },
  },
  computed: {
    style() {
      var res = "";
      if (this.$store.getters.isMobile) {
        res = "width: 100%";
      } else {
        res = "width: calc(100% - 300px)";
      }
      return res;
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 15px 0px 0px !important;
  width: auto;
}

.v-card {
  display: flex !important;
}
.rotated {
  transform-origin: 113px 113px;
  width: 226px;
}
.parent-side {
  border-radius: 15px 15px 0px 15px !important;
  width: 100%;
}
.flex-card {
  display: flex;
  direction: column;
  justify-content: center;
  align-items: center;
}
#textWrap {
  line-break: anywhere;
  text-align: center;
  text-wrap: wrap;
  margin: auto;
}
.croppedText {
  height: 50px;
  width: 100%;
  padding: 10px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin: 0 10px 0 10px;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  color: #000;
  white-space: nowrap;
}
.introductionTitle {
  padding: 10px;
  margin: 5px;
  font-size: 1.1rem;
  font-weight: 600;
}
</style>
